export type NotNull<T> = T extends null ? never : T

export interface TestProps {
  testId?: string
}
export const isNumberGuard = (value: unknown): value is number => typeof value === 'number'
